import type {
  Scalars,
  UpdateColourPaletteMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface UpdateColourPaletteTRPCInput {
  Id: string;
  Name: string;
  Settings: Scalars['jsonb']['input'];
}

/**
 * Maps TRPC mutation response to match the GraphQL mutation structure
 */
const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): UpdateColourPaletteMutation => {
  return {
    update_colour_palette_by_pk: {
      __typename: 'colour_palette',
      Id: trpcData.Id,
    },
  };
};

export const useUpdateColourPaletteTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.colourPalette.update.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.colourPalette.getColourPalettes.queryKey(),
        });
      },
    }),
  });

  return {
    updateColourPalette: async (
      variables: UpdateColourPaletteTRPCInput
    ): Promise<UpdateColourPaletteMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
